import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c41deb7&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=5c41deb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41deb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c41deb7')) {
      api.createRecord('5c41deb7', component.options)
    } else {
      api.reload('5c41deb7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c41deb7&scoped=true", function () {
      api.rerender('5c41deb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkGrantCleanup/index.vue"
export default component.exports